<div class="file-upload-wrapper">
    <div [id]="dashboardSelector.replace('#', '')"></div>

    <button
        vpg-button
        id="file-upload-trigger-button"
        aria-label="Open Upload Modal"
        role="button" 
        size="small"
        [class]="triggerButtonSelector.replace('.', '')"
        variant="primary"
        [disabled]="(uppyImages?.length || 0) >= maxFilesAllowed">
        {{ buttonText }}
    </button>

    <ng-container *ngIf="uppyImages">
        <div
            class="image-container"
            [ngClass]="{
                'layout-row': imageLayoutDirection === 'row',
                'layout-column': imageLayoutDirection === 'column',
                'layout-grid': imageLayoutDirection === 'grid'
            }">
            <div
                *ngFor="let image of uppyImages"
                class="image-wrapper"
                [ngStyle]="{
                    width: imageSize + 'px',
                    height: imageSize + 'px'
                }">
                <img
                    [src]="image?.directLink"
                    [alt]="image?.name || 'Uploaded Image'"
                    [width]="imageSize"
                    [height]="imageSize" />
                <button
                    vpg-button
                    id="file-upload-remove-image-button"
                    aria-label="Remove Image"
                    role="button" 
                    size="small"
                    class="remove-btn"
                    (click)="removeImage(image)">
                    ✕
                </button>
            </div>
        </div>
    </ng-container>

    <button
        vpg-button
        id="file-upload-clear-all-button"
        aria-label="Clear all images"
        role="button" 
        size="small"
        variant="secondary"
        *ngIf="uppyImages?.length"
        class="clear-all-btn"
        (click)="clearAllImages()">
        Clear All
    </button>

    <div
        *ngIf="(uppyImages?.length || 0) >= maxFilesAllowed"
        class="max-limit-msg">
        Maximum {{ maxFilesAllowed }} image(s) allowed. Remove one to upload more.
    </div>
</div>
